import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import  { Icon, Menu, Popup } from 'semantic-ui-react'
import './dashMenu.sass'

function DashMenu(){

    const rol = useSelector(state => state.rol)
    const ultra = useSelector(state => state.ultraUser)
    
    const navigate = useNavigate();
    const { t } = useTranslation()
    const location = useLocation()
    const section = location.pathname.split("/").length >= 3 ? location.pathname.split("/")[2].toLowerCase() : ""

    
    return(
        <Menu icon="labeled" vertical fluid borderless size="massive" className="dashMenu">
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='/'
                    active={ section === ''}
                    onClick={() => {navigate("/dashboard/")}}>
                        <Popup
                            trigger={
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="45.796" height="42.006" viewBox="0 0 45.796 42.006">
                                        <path id="dashboard" d="M45.6,20.928A22.894,22.894,0,0,0,0,23.91,22.661,22.661,0,0,0,7.172,40.531a9.234,9.234,0,0,0,6.4,2.457H32.2A9.528,9.528,0,0,0,38.9,40.262a22.787,22.787,0,0,0,6.7-19.334Zm-9.365,16.6A5.723,5.723,0,0,1,32.2,39.172H13.57a5.46,5.46,0,0,1-3.779-1.414A18.887,18.887,0,0,1,3.816,23.91,19.1,19.1,0,0,1,10.184,9.683,18.851,18.851,0,0,1,22.867,4.832a20.133,20.133,0,0,1,2.24.126A19.067,19.067,0,0,1,36.231,37.535ZM14.894,32.085a1.909,1.909,0,0,1-2.671,2.728A15.264,15.264,0,0,1,25.075,8.8a1.908,1.908,0,0,1,1.616,2.162,1.887,1.887,0,0,1-2.162,1.618,11.447,11.447,0,0,0-9.634,19.5ZM38,21.729a15.4,15.4,0,0,1,.155,2.181,15.131,15.131,0,0,1-4.594,10.905,1.91,1.91,0,0,1-2.671-2.732,11.409,11.409,0,0,0,3.327-9.808A1.909,1.909,0,1,1,38,21.729Zm-11.434,1.2a3.879,3.879,0,1,1-2.7-2.7l7.213-7.213a1.908,1.908,0,1,1,2.7,2.7Z" transform="translate(0 -0.982)"/>
                                    </svg>
                                    <br/><span className="itemName">{t('DASHBOARD')}</span><br/>
                                </div>
                            }
                            content={t('DASHBOARD_DESC')}
                            position="right center"
                            mouseEnterDelay={800}
                            wide
                        />
                        {/* <img src="/dashboard.svg"/> */}
                </Menu.Item>
            }
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='/charts'
                    active={ section === 'charts'}
                    onClick={() => {navigate("/dashboard/charts")}}
                >
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 3v18h18" />
                            <path d="M18 17V9" />
                            <path d="M13 17V5" />
                            <path d="M8 17v-3" />
                        </svg>
                        <br/><span className="itemName">{t('CHARTS')}</span><br/>
                    </div>
                </Menu.Item>
            }
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='processArea'
                    active={ section === 'frameworks'}
                    onClick={() => { navigate("/dashboard/frameworks")}}
                    style={{padding: "0 1.15 !important"}}
                    >
                        <Popup
                            trigger={
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="48.799" viewBox="0 0 45 48.799">
                                        <path id="frameworks" d="M40.872,8.532l-12.3-7.1a10.233,10.233,0,0,0-10.2,0l-12.3,7.1a10.231,10.231,0,0,0-5.1,8.835v14.2a10.235,10.235,0,0,0,5.1,8.837l12.3,7.1a10.227,10.227,0,0,0,10.2,0l12.3-7.1a10.235,10.235,0,0,0,5.1-8.837v-14.2a10.231,10.231,0,0,0-5.1-8.835ZM20.412,4.968a6.121,6.121,0,0,1,6.121,0l12.3,7.1a6.009,6.009,0,0,1,.875.673L27.07,20.034a7.2,7.2,0,0,1-7.195,0L7.239,12.74a6.009,6.009,0,0,1,.875-.673Zm-12.3,31.9a6.138,6.138,0,0,1-3.061-5.305v-14.2A5.9,5.9,0,0,1,5.2,16.276L17.835,23.57a11.2,11.2,0,0,0,3.6,1.3V44.391a5.9,5.9,0,0,1-1.02-.42Zm33.778-5.305a6.138,6.138,0,0,1-3.061,5.305l-12.3,7.1a5.9,5.9,0,0,1-1.02.42V24.866a11.2,11.2,0,0,0,3.6-1.3l12.636-7.295a5.9,5.9,0,0,1,.145,1.092Z" transform="translate(-0.973 -0.069)"/>
                                    </svg>
                                    <br/><span className="itemName">{t('MY_FRAMEWORKS')}</span><br/>
                                </div>
                            }
                            content={t('MY_FRAMEWORKS_DESC')}
                            position="right center"
                            mouseEnterDelay={800}
                            wide
                        />
                </Menu.Item>
            }
            {
                rol.length > 0 && 
                <Menu.Item
                    name='report'
                    active={ section === 'report'}
                    onClick={() => { navigate("/dashboard/report")}}>
                        <Popup
                            trigger={
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="43.122" height="32.496" viewBox="0 0 43.122 32.496">
                                        <g id="list" transform="translate(0.217 -0.404)">
                                            <path id="Trazado_2115" data-name="Trazado 2115" d="M9.177,9.355H35.06A2.677,2.677,0,0,0,35.06,4H9.177a2.677,2.677,0,0,0,0,5.355Z" transform="translate(5.168 -2.337)"/>
                                            <path id="Trazado_2116" data-name="Trazado 2116" d="M35.06,11H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z" transform="translate(5.168 3.158)"/>
                                            <path id="Trazado_2117" data-name="Trazado 2117" d="M35.06,18H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z" transform="translate(5.168 8.653)"/>
                                            <ellipse id="Elipse_80" data-name="Elipse 80" cx="4.5" cy="4" rx="4.5" ry="4" transform="translate(-0.217 0.404)"/>
                                            <ellipse id="Elipse_81" data-name="Elipse 81" cx="4.462" cy="4.462" rx="4.462" ry="4.462" transform="translate(0.065 11.48)"/>
                                            <ellipse id="Elipse_82" data-name="Elipse 82" cx="4.462" cy="4.462" rx="4.462" ry="4.462" transform="translate(0.065 23.975)"/>
                                        </g>
                                    </svg>
                                    <br/><span className="itemName">{t('MY_ACTIVITIES')}</span><br/>
                                </div>
                            }
                            content={t('MY_TASKS_DESC')}
                            position="right center"
                            mouseEnterDelay={800}
                            wide
                        />
                </Menu.Item>
            }
            {
                rol.length > 0 &&
                <Menu.Item
                    name='library'
                    active={ section === 'library'}
                    onClick = {() => {navigate("/dashboard/library")}}
                >
                    <svg id="Layer_1" width="60" height="40.496" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                        <path d="m17 14a1 1 0 0 1 -1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zm-4 3h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm9-6.515v8.515a5.006 5.006 0 0 1 -5 5h-10a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h4.515a6.958 6.958 0 0 1 4.95 2.05l3.484 3.486a6.951 6.951 0 0 1 2.051 4.949zm-6.949-7.021a5.01 5.01 0 0 0 -1.051-.78v4.316a1 1 0 0 0 1 1h4.316a4.983 4.983 0 0 0 -.781-1.05zm4.949 7.021c0-.165-.032-.323-.047-.485h-4.953a3 3 0 0 1 -3-3v-4.953c-.162-.015-.321-.047-.485-.047h-4.515a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3z"/>
                    </svg>
                    <br/><span className="itemName">{t('LIBRARY')}</span><br/>
                </Menu.Item>
            }
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='gantt'
                    active={ section === 'gantt'}
                    onClick = {() => {navigate("/dashboard/gantt")}}
                >
                    <Popup
                        trigger={
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 3v18h18" />
                                    <path d="M7 6h10" stroke-width="1" />
                                    <path d="M9 10h8" stroke-width="1" />
                                    <path d="M7 14h12" stroke-width="1" />
                                    <path d="M11 18h6" stroke-width="1" />
                                    <path d="M3 6h2" />
                                    <path d="M3 10h2" />
                                    <path d="M3 14h2" />
                                    <path d="M3 18h2" />
                                </svg>
                                <br/><span className="itemName">{t('GANTT')}</span><br/>
                            </div>
                        }
                        content={t('GANTT_DESC')}
                        position="right center"
                        mouseEnterDelay={800}
                        wide
                    />
                </Menu.Item>
            }
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='diagrams'
                    active={ section === 'diagrams'}
                    onClick = {() => {navigate("/dashboard/diagrams")}}
                >
                    <div>
                        <svg od="dgsvg" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                            <path 
                                id="diagram" 
                                d="M31.5014 24.19V22.4994C31.5014 21.3059 31.0273 20.1613 30.1833 19.3173C29.3394 18.4734 28.1947 17.9992 27.0012 17.9992H19.5009V14.8491C21.322 14.4774 22.9402 13.4427 24.0419 11.9456C25.1435 10.4485 25.65 8.59576 25.4631 6.74647C25.2763 4.89719 24.4095 3.18315 23.0307 1.93665C21.652 0.69015 19.8595 0 18.0008 0C16.1421 0 14.3496 0.69015 12.9708 1.93665C11.5921 3.18315 10.7253 4.89719 10.5384 6.74647C10.3516 8.59576 10.8581 10.4485 11.9597 11.9456C13.0613 13.4427 14.6796 14.4774 16.5007 14.8491V17.9992H9.0004C7.80688 17.9992 6.66224 18.4734 5.81829 19.3173C4.97434 20.1613 4.50021 21.3059 4.50021 22.4994V24.19C3.08616 24.5551 1.85381 25.4234 1.03416 26.6321C0.214503 27.8409 -0.136181 29.307 0.0478385 30.7558C0.231858 32.2046 0.937947 33.5365 2.03375 34.5019C3.12956 35.4674 4.53985 36 6.00027 36C7.4607 36 8.87099 35.4674 9.9668 34.5019C11.0626 33.5365 11.7687 32.2046 11.9527 30.7558C12.1367 29.307 11.786 27.8409 10.9664 26.6321C10.1467 25.4234 8.91439 24.5551 7.50034 24.19V22.4994C7.50034 22.1016 7.65838 21.7201 7.9397 21.4387C8.22102 21.1574 8.60256 20.9994 9.0004 20.9994H16.5007V24.19C15.0867 24.5551 13.8543 25.4234 13.0347 26.6321C12.215 27.8409 11.8643 29.307 12.0484 30.7558C12.2324 32.2046 12.9385 33.5365 14.0343 34.5019C15.1301 35.4674 16.5404 36 18.0008 36C19.4612 36 20.8715 35.4674 21.9673 34.5019C23.0631 33.5365 23.7692 32.2046 23.9532 30.7558C24.1372 29.307 23.7866 27.8409 22.9669 26.6321C22.1473 25.4234 20.9149 24.5551 19.5009 24.19V20.9994H27.0012C27.399 20.9994 27.7806 21.1574 28.0619 21.4387C28.3432 21.7201 28.5012 22.1016 28.5012 22.4994V24.19C27.0872 24.5551 25.8548 25.4234 25.0352 26.6321C24.2155 27.8409 23.8649 29.307 24.0489 30.7558C24.2329 32.2046 24.939 33.5365 26.0348 34.5019C27.1306 35.4674 28.5409 36 30.0013 36C31.4617 36 32.872 35.4674 33.9678 34.5019C35.0636 33.5365 35.7697 32.2046 35.9537 30.7558C36.1378 29.307 35.7871 27.8409 34.9674 26.6321C34.1478 25.4234 32.9154 24.5551 31.5014 24.19ZM13.5006 7.49879C13.5006 6.60874 13.7645 5.73867 14.259 4.99862C14.7535 4.25857 15.4563 3.68176 16.2786 3.34116C17.1009 3.00055 18.0058 2.91143 18.8787 3.08507C19.7517 3.25871 20.5535 3.68731 21.1829 4.31668C21.8123 4.94604 22.2409 5.7479 22.4145 6.62085C22.5882 7.4938 22.499 8.39864 22.1584 9.22094C21.8178 10.0432 21.241 10.7461 20.501 11.2406C19.7609 11.7351 18.8908 11.999 18.0008 11.999C16.8073 11.999 15.6626 11.5249 14.8187 10.6809C13.9747 9.83696 13.5006 8.69232 13.5006 7.49879ZM9.0004 29.9998C9.0004 30.5931 8.82445 31.1732 8.49479 31.6666C8.16513 32.1599 7.69658 32.5445 7.14837 32.7715C6.60017 32.9986 5.99695 33.058 5.41498 32.9422C4.83301 32.8265 4.29844 32.5408 3.87886 32.1212C3.45929 31.7016 3.17355 31.167 3.05779 30.5851C2.94203 30.0031 3.00144 29.3999 3.22852 28.8517C3.45559 28.3035 3.84012 27.8349 4.33349 27.5052C4.82686 27.1756 5.4069 26.9996 6.00027 26.9996C6.79596 26.9996 7.55905 27.3157 8.12169 27.8784C8.68432 28.441 9.0004 29.2041 9.0004 29.9998ZM21.0009 29.9998C21.0009 30.5931 20.825 31.1732 20.4953 31.6666C20.1657 32.1599 19.6971 32.5445 19.1489 32.7715C18.6007 32.9986 17.9975 33.058 17.4155 32.9422C16.8335 32.8265 16.299 32.5408 15.8794 32.1212C15.4598 31.7016 15.1741 31.167 15.0583 30.5851C14.9425 30.0031 15.002 29.3999 15.229 28.8517C15.4561 28.3035 15.8406 27.8349 16.334 27.5052C16.8274 27.1756 17.4074 26.9996 18.0008 26.9996C18.7965 26.9996 19.5596 27.3157 20.1222 27.8784C20.6848 28.441 21.0009 29.2041 21.0009 29.9998ZM30.0013 32.9999C29.4079 32.9999 28.8279 32.8239 28.3345 32.4943C27.8412 32.1646 27.4566 31.6961 27.2296 31.1479C27.0025 30.5997 26.9431 29.9964 27.0588 29.4145C27.1746 28.8325 27.4603 28.2979 27.8799 27.8784C28.2995 27.4588 28.834 27.173 29.416 27.0573C29.998 26.9415 30.6012 27.0009 31.1494 27.228C31.6976 27.4551 32.1662 27.8396 32.4958 28.333C32.8255 28.8264 33.0014 29.4064 33.0014 29.9998C33.0014 30.7955 32.6854 31.5585 32.1227 32.1212C31.5601 32.6838 30.797 32.9999 30.0013 32.9999Z"
                                fill="currentColor"
                            />
                        </svg>
                        <br/><span className="itemName">{t('DIAGRAMS')}</span><br/>
                    </div>
                </Menu.Item>
            }
            {
                rol.length > 0 && rol.findIndex(itm => itm === "Administrator") !== -1 &&
                <Menu.Item
                    name='profile'
                    active={ section === 'users' || section === 'adduser'}
                    onClick={() => {navigate("/dashboard/users")}}>
                        <Popup
                            trigger={
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="44.971" height="44.971" viewBox="0 0 44.971 44.971">
                                        <path id="users" d="M13.741,23.818a8.245,8.245,0,1,1,8.245-8.245,8.245,8.245,0,0,1-8.245,8.245Zm0-12.825a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,13.741,10.993ZM27.482,42.139v-.916A13.741,13.741,0,1,0,0,41.223v.916a1.832,1.832,0,1,0,3.664,0v-.916a10.077,10.077,0,1,1,20.153,0v.916a1.832,1.832,0,1,0,3.664,0Zm16.489-9.161A12.825,12.825,0,0,0,22.6,23.42a1.832,1.832,0,1,0,2.444,2.73,9.161,9.161,0,0,1,15.267,6.828,1.832,1.832,0,1,0,3.664,0ZM32.062,16.489a8.245,8.245,0,1,1,8.245-8.245,8.245,8.245,0,0,1-8.245,8.245Zm0-12.825a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,32.062,3.664Z" transform="translate(0.5 0.5)"/>
                                    </svg>
                                    <br/><span className="itemName">{t('USERS')}</span><br/>
                                </div>
                            }
                            content={t('USERS_DESC')}
                            position="right center"
                            mouseEnterDelay={800}
                            wide
                        />
                </Menu.Item> 
            }
            {
                rol.length > 0 &&
                <Menu.Item
                    name='profile'
                    active={section === 'profile'}
                    onClick={() => {navigate("/dashboard/profile")}}
                >
                    <Icon name="user outline"/>
                    <span className="itemName">{t('PROFILE')}</span><br/>

                </Menu.Item>
            }
            {
                ultra &&
                <Menu.Item
                    name="ultraConfig"
                    active={section === 'ultraConfig'}
                    onClick={() => {navigate("/dashboard/ultraConfig")}}
                >
                    <Icon name="configure"/>
                    <span className="itemName">{t('CONFIG')}</span>
                </Menu.Item>
            }
        </Menu>
    )   
}

export default DashMenu;